import React, { useEffect } from "react";
import { decoded } from "../Utils/UserProfile";
import { useNavigate } from "react-router";
import PredictionData from "../components/PredictionData";

const Prediction = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (decoded === null) {
      window.location.href = "/";
    }
  }, [decoded]);
  return (
    <div className="innerContainer">
      <div className="dashboardPage">
        <PredictionData />
      </div>
    </div>
  );
};

export default Prediction;
